import ProgramToken from '@apps/crm/admin/tokens/program'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Payments)',
  collection: {
    endpoint: '/api/admin/finance/payments',
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Program)', key: 'program', primary: true, format: (payment) => <ProgramToken { ...payment.invoice.program } /> },
      { label: 't(Method)', key: 'method', collapsing: true },
      { label: 't(Date)', key: 'date', collapsing: true, format: 'date' },
      { label: 't(Amount)', key: 'amount', collapsing: true, primary: true, format: 'currency' }
    ],
    empty: {
      title: 't(No Payments)',
      text: 't(There are no payments for this contact)',
      svg: 'dollar_sign'
    },
    entity: 'payments',
    defaultQuery: { contact_id: props.contact.id },
    defaultSort: { key: 'created_at', order: 'desc' },
    onClick: (record) => context.router.push(`/admin/finance/payments/${record.id}`)
  }
})

export default Panel(null, mapPropsToPanel)
